let currentDate = new Date();

const Footer = () => {
    return (
        <footer id="footer">
            <span>&copy; Copyright - {currentDate.getFullYear()}</span>
        </footer>
    );
}

export default Footer;